import { TenantConfiguration, toTenantConfiguration } from '@faro/study-designer-model';
import axios from 'axios';

export const tenantConfigurationClient = {
    get: (signal?: AbortSignal): Promise<TenantConfiguration> => {
        return axios
            .get('/api/study-designer/system/tenant/configuration', { signal })
            .then(response => toTenantConfiguration(response.data));
    },
};
